exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mdlp-info{width:100%;height:100%!important;flex:content}.mdlp-qa-dialog{width:80%;height:80%;max-width:768px;margin:auto}.md-dialog-container{width:95%;height:95%;max-width:95%;max-height:95%}.md-dialog-container,.md-overlay{transition:none!important}.close-dialog .md-dialog-container{height:auto;width:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./Components/supportNew/MainSupport.vue
// module id = 426
// module chunks = 0